import React from "react";
import './home.css';
import TitleSection from "./title-sec/titleSection";
import WorkSection from "./work-section/work-section";
import Features from "./features/features";
import InteractiveVideos from "./interactive-videos/interactive-videos";
import Integrations from "./integrations/integrations";
import GetStarted from "./get-started/get-started";


function Home() {
   return (
       <div className="home-page animate-page page-content">
          <div className="title-sec">
             <TitleSection />
          </div>
          <div className="work-sec sec-bottom-padding" id={'how-it-works'}>
             <WorkSection />
          </div>
          <div className="features-sec sec-bottom-padding" id={'features'}>
             <Features />
          </div>
          <div className="interactive-sec sec-bottom-padding" id={'interactive-videos'}>
             <InteractiveVideos />
          </div>
          <div className="integrations-sec sec-bottom-padding bottom-padding-150" id={'integrations'}>
             <Integrations />
          </div>
          <div className="get-started-sec">
             <GetStarted />
          </div>
       </div>
   )
}

export default Home;
